class FeatureShowcase {
  constructor(section) {
    this.section = section;
    this.animation = section.dataset.animation || 'fade_up';
    this.mobileFade = section.dataset.mobileFade === 'true';
    this.parallaxSpeed = Number.parseFloat(section.dataset.parallaxSpeed || '0.3');
    this.cards = Array.from(section.querySelectorAll('[data-animate-card]'));
    this.parallaxFrames = Array.from(section.querySelectorAll('.fms-card__media-frame--parallax'));
    this.isDesktop = window.matchMedia('(min-width: 768px)').matches;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.rafId = null;
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);

    if (this.animation !== 'none' && !this.reduceMotion) {
      this.section.classList.add('feature-media-showcase--animated');
    }

    this.initObserver();
    this.updateParallaxBinding();
    window.addEventListener('resize', this.onResize, { passive: true });
  }

  initObserver() {
    if (!this.cards.length) return;

    if (!('IntersectionObserver' in window) || this.animation === 'none' || this.reduceMotion) {
      this.cards.forEach((card) => card.classList.add('is-in-view'));
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
          }
        });
      },
      {
        threshold: 0.3,
      }
    );

    this.cards.forEach((card) => this.observer.observe(card));
  }

  updateParallaxBinding() {
    const allowParallax = this.animation === 'parallax' && this.isDesktop && !this.reduceMotion;

    if (!allowParallax) {
      this.stopParallax();
      this.resetParallax();
      if (!this.isDesktop && this.mobileFade) {
        this.cards.forEach((card) => card.classList.add('is-in-view'));
      }
      return;
    }

    this.startParallax();
  }

  startParallax() {
    if (!this.parallaxFrames.length || this.scrollBound) return;
    this.scrollBound = true;
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  }

  stopParallax() {
    if (!this.scrollBound) return;
    this.scrollBound = false;
    window.removeEventListener('scroll', this.onScroll);
    if (this.rafId) {
      window.cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
  }

  resetParallax() {
    this.parallaxFrames.forEach((frame) => {
      frame.style.transform = '';
    });
  }

  onResize() {
    this.isDesktop = window.matchMedia('(min-width: 768px)').matches;
    this.updateParallaxBinding();
  }

  onScroll() {
    if (this.rafId) return;
    this.rafId = window.requestAnimationFrame(() => {
      this.rafId = null;
      this.parallaxFrames.forEach((frame) => {
        const rect = frame.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
        const clamped = Math.min(Math.max(progress, 0), 1);
        const translateY = (0.5 - clamped) * 100 * this.parallaxSpeed;
        frame.style.transform = `translate3d(0, ${translateY}px, 0)`;
      });
    });
  }
}

document.querySelectorAll('.feature-media-showcase').forEach((section) => {
  new FeatureShowcase(section);
});